"use strict";

import {Fancybox} from "/../../main/node_modules/@fancyapps/ui";

const FancyboxCustom = () => {
    const init = () => {
        $(document).ready(function () {



        });
    };

    return {
        init: init
    };
};

export default FancyboxCustom;